module.exports = __webpack_public_path__ + "static/media/Mercedes-Benz3.a11a4a01.mp3";